import { render, staticRenderFns } from "./seedingCost.vue?vue&type=template&id=2f3a4751&scoped=true&"
import script from "./seedingCost.vue?vue&type=script&lang=js&"
export * from "./seedingCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3a4751",
  null
  
)

export default component.exports